export const UTM_FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;
export type UtmField = (typeof UTM_FIELDS)[number];

export function visitId(value: unknown): string | null {
  return typeof value === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value) ? value : null;
}

export function landingPath(value: unknown): string {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//") || /[\\\u0000-\u0020\u007f]/.test(value)) return "/";
  try {
    const path = decodeURIComponent(new URL(value, "https://tradesfolk.co").pathname);
    if (path.startsWith("//") || /[\\\u0000-\u0020\u007f]/.test(path)) return "/";
    // Keep account, conversation, job and review identifiers out of analytics.
    // Public result/profile routes can also carry identifiers for personal data.
    const category = path.split("/")[1];
    if (["homeowner", "dashboard", "admin", "account", "auth", "api", "review", "snap", "cost-estimator", "tradesperson", "jobs", "ask"].includes(category)) {
      return `/${category}`;
    }
    return path.slice(0, 500) || "/";
  } catch {
    return "/";
  }
}

export function campaignVisit(value: unknown) {
  if (!value || typeof value !== "object") return null;
  const input = value as Record<string, unknown>;
  const id = visitId(input.visit_id);
  if (!id) return null;
  const fields = Object.fromEntries(UTM_FIELDS.map((field) => {
    const value = input[field];
    return [field, typeof value === "string" ? value.trim().slice(0, field === "utm_source" || field === "utm_medium" ? 100 : 200) || null : null];
  })) as Record<UtmField, string | null>;
  if (!UTM_FIELDS.some((field) => fields[field])) return null;
  return { id, ...fields, landing_path: landingPath(input.landing_path) };
}
